import styled from 'styled-components';
import React, {FC} from 'react';
import {mediaBreakpointDown, fontWeights, transition} from '../../../lib/styleVariables';
import {fontSizesMixinsR4, paletteR4} from '../../../lib/styleVariablesR4';

const StyledForm = styled.div`
  width: 100%;
  border-radius: 100px;
  overflow: hidden;
  display: flex;

  ${mediaBreakpointDown('tablet')} {
    border-radius: 0;
    flex-direction: column;
  }
`;

const StyledInput = styled.input`
  ${fontSizesMixinsR4.h5()};
  padding: 0 24px;
  height: 52px;
  font-weight: ${fontWeights.semibold};
  background: ${paletteR4.white.base};
  border: none;
  flex: 1;
  outline: none;

  &::-webkit-input-placeholder {
    color: ${paletteR4.gray.base};
  }
  &::-moz-placeholder {
    color: ${paletteR4.gray.base};
  }
  &:-ms-input-placeholder {
    color: ${paletteR4.gray.base};
  }
  &:-moz-placeholder {
    color: ${paletteR4.gray.base};
  }

  ${mediaBreakpointDown('tablet')} {
    flex: none;
    margin-bottom: 8px;
    border-radius: 100px;
  }
`;

const StyledButton = styled.button`
  ${fontSizesMixinsR4.h5()};
  background: ${paletteR4.red.base};
  font-weight: ${fontWeights.semibold};
  height: 52px;
  padding: 0 43px 0 30px;
  border: none;
  cursor: pointer;
  color: ${paletteR4.white.base};
  transition: ${transition.fast};
  outline: none;

  &:hover {
    background: ${paletteR4.red.lowlight};
  }

  ${mediaBreakpointDown('tablet')} {
    width: 100%;
    border-radius: 100px;
  }
`;

const StyledSubscriptionForm = styled.div`
  width: 100%;
  max-width: 480px;
`;

export type SubscriptionFormData = {
  formId: string;
  portalId: string;
};

interface FormProps {
  onSubmit: (emaiL: string) => void;
  buttonLabel: string;
  inputPlaceholder: string;

}

export const SubscriptionForm: FC<FormProps> = ({onSubmit, buttonLabel, inputPlaceholder}) => {
  const emailInputRef = React.useRef<HTMLInputElement>(null as any);

  const handleSubmit = () => {
    const inputVal = emailInputRef.current.value;
    if (inputVal)
      onSubmit(inputVal);
  };

  return (
    <StyledSubscriptionForm>
      <StyledForm>
        <StyledInput
          type="email"
          name="email"
          ref={emailInputRef as any}
          required
          autoFocus
          placeholder={inputPlaceholder}
        />
        <StyledButton type="button" onClick={handleSubmit}>
          {buttonLabel}
        </StyledButton>
      </StyledForm>
    </StyledSubscriptionForm>
  );
};
